import { Fragment } from 'preact';

import { Spinner } from '@/components';
import HiddenLabel from './HiddenLabel';
import HandleTabIndex from './HandleTabIndex';

/* Inputs */
const isIOS =
	navigator.userAgent.match(/(iPod|iPhone|iPad)/gi) ||
	(navigator.userAgent.match(/safari/gi) && navigator.maxTouchPoints > 1);
//const isSafari = navigator.userAgent.match(/Safari/gi) !== null;

function determineAriaProps({ block = {}, showErrors, state = {}, placeholder }) {
	return {
		...(block.properties?.required && {
			'aria-required': true
		}),
		...(showErrors &&
			state.showError &&
			!state.isLoading && {
				'aria-invalid': true,
				'aria-describedby': `error-message-${block.id ?? block.data_field}`
			}),
		...((placeholder || block?.properties?.placeholder || block?.placeholder) && {
			'aria-describedby': `${block.id ?? block.data_field}-placeholder ${
				showErrors && state.showError && !state.isLoading
					? `error-message-${block.id ?? block.data_field}`
					: ''
			}`
		})
	};
}

export default function TextInput({
	children,
	block,
	state,
	setValue = () => {},
	type,
	showErrors,
	placeholder
}) {
	const id = `element-${block.typeName ?? type ?? ''}-${block.id ?? block.data_field}`;

	const props = {
		onKeyDown: event => {
			if (block.typeName !== 'textarea' && event.keyCode === 13) {
				event.preventDefault();
			}
		},
		onChange: event => setValue(event.target.value),
		onInput: event => setValue(event.target.value),
		className: showErrors && state.showError && !state.isLoading ? 'error' : '',
		placeholder:
			placeholder ?? (block?.properties?.placeholder || block?.placeholder || ''),
		value: state.value ? state.value : null,
		id,
		...(isIOS && {
			style: {
				fontSize: '16px'
			}
		}),
		type: type ?? block.properties?.format ?? 'text',
		...determineAriaProps({ block, showErrors, state, placeholder }),
		'data-testid': block.typeName
	};

	if (block.typeName === 'textarea') {
		return (
			<Fragment>
				<HandleTabIndex
					component="textarea"
					{...props}
				>
					{navigator.userAgent.match(/Trident/) !== null && props.placeholder
						? props.placeholder
						: null}
				</HandleTabIndex>

				{props.placeholder && (
					<InvisiblePlaceholder
						placeholder={props.placeholder}
						id={`${block.id ?? block.data_field}-placeholder`}
					/>
				)}
			</Fragment>
		);
	}

	return (
		<div className="input-wrap">
			{['contact', 'checkbox', 'radio', 'select'].indexOf(block.typeName) > -1 && (
				<HiddenLabel
					labelFor={id}
					block={block}
				/>
			)}
			<HandleTabIndex
				component="input"
				{...props}
			/>
			{state.isLoading && <Spinner />}

			{props.placeholder && (
				<InvisiblePlaceholder
					placeholder={props.placeholder}
					id={`${block.id ?? block.data_field}-placeholder`}
				/>
			)}
		</div>
	);
}

const hiddenCss = {
	position: 'absolute',
	width: '1px',
	height: '1px',
	margin: '-1px',
	padding: '0',
	overflow: 'hidden',
	clip: 'rect(0, 0, 0, 0)',
	border: '0'
};

function InvisiblePlaceholder({ placeholder, id }) {
	return (
		<span
			id={id}
			style={hiddenCss}
		>
			{placeholder}
		</span>
	);
}
